import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionLabel({
  children,
  tone = 'light'
}: SectionLabelProps) {
  return <div className="flex items-center gap-3" data-id="element-136" data-mp="2yet2t5hjt6mi">
      <span className="block h-px w-8 bg-bronze-500" aria-hidden="true" data-id="element-137" data-mp="2yg42at3yns7t" />
      <span className={`text-xs font-medium uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-bronze-300' : 'text-bronze-600'}`} data-id="element-138" data-mp="33ddycrluv24m">
        {children}
      </span>
    </div>;
}